export const dataSelector = (state) => state.admin.pendingContent.data;
export const selectedSelector = (state) => state.admin.pendingContent.selected;
export const paginationSelector = (state) => state.admin.pendingContent.pagination;
export const modalsSelector = (state) => state.admin.pendingContent.modals;
export const loadingSelector = (state) => state.admin.pendingContent.loading;
